module.exports = __webpack_public_path__ + "public/images/partners/partner-2.7c60e14ebc948ac86a17925abf2dac1c.png";